import './AboutPage.css';

const sections = [
  {
    heading: null,
    body: "Luke's Breakfast Blog is a passion project built by Luke McCartney — a lifelong breakfast enthusiast. This site exists to celebrate the full English breakfast and vegan alternatives.",
    image: null,
  },
  {
    heading: 'The Full English — A Philosophy',
    body: "Ask ten people what belongs in a full English breakfast and you'll get ten different arguments. But there are a handful of principles that separate a truly great fry-up from a disappointing pile of things on a plate.",
    image: '/images/farmhouse-full-english2.jpeg',
  },
  {
    heading: 'The Bacon',
    body: "It should be cooked in a lightly oiled pan until the fat renders and the edges catch and crisp. Steamed-looking bacon is a red flag. The fat should be slightly chewy and the lean part deeply coloured. Smoked or unsmoked is a matter of taste — both are valid. If you're doing this yourself definitely purchase from a butcher if possible!",
    image: '/images/bacon.jpeg',
  },
  {
    heading: 'The Eggs',
    body: "Eggs can appear in several forms — fried, scrambled, or poached — and a great full English respects all three. A fried egg should have fully set whites and a yolk that runs when broken - this is essential. Scrambled eggs, if offered, must be soft and barely set. Poached eggs are the most technically demanding but reward the effort with a clean, elegant result. Vegan alternatives can vary and this is dependent on taste!",
    image: '/images/fried-eggs.jpeg',
  },
  {
    heading: 'Sausages',
    body: "Pork sausages with a high meat content — 80% or above. They should be browned all over, not grey. The skin should have some snap and the inside should be juicy and well-seasoned. Cheap sausages that split and weep water into the pan drag the whole plate down, these should be avoided!",
    image: '/images/sausages.jpeg',
  },
  {
    heading: 'Beans & the Rest',
    body: "Baked beans, warmed through - fried preferably. Grilled tomatoes, halved and cooked cut-side down until caramelised. Mushrooms, whole or thickly sliced, cooked in oil. Toast. Simple",
    image: '/images/beans.jpeg',
  },
];

function AboutPage() {
  return (
    <main className="about-page">
      <h1 className="about-page-title">About This Blog</h1>

      <article className="about-article">
        {sections.map((section, i) => (
          <section key={i} className="about-section">
            {section.heading && <h2 className="about-section-heading">{section.heading}</h2>}
            <p className="about-section-body">{section.body}</p>
            {section.image && (
              <img src={section.image} alt={section.heading} className="about-section-image" />
            )}
          </section>
        ))}
      </article>
    </main>
  );
}

export default AboutPage;
